import { createFileRoute, Link } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'

export const Route = createFileRoute('/_authed/forbidden')({
  component: () => (
    <div className="grid justify-items-start gap-4">
      <h1 className="text-2xl font-semibold">Forbidden</h1>
      <p className="text-muted-foreground">Your role does not allow access to this page.</p>
      <Button asChild variant="outline">
        <Link to="/">Back to dashboard</Link>
      </Button>
    </div>
  ),
})
